var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9996 11.0056C21.9996 17.0782 17.0756 21.9996 10.9998 21.9996C4.92983 21.9996 0 17.0763 0 11.0056C0 4.92329 4.92983 0 10.9998 0C17.0756 0 21.9996 4.92329 21.9996 11.0056ZM12.2611 3.82408C11.8496 3.78551 11.4266 3.77009 10.9979 3.77009C10.5749 3.77009 10.1519 3.78745 9.74042 3.82408V9.69231H12.2592V3.82408H12.2611ZM18.085 7.24512C17.1967 6.95394 16.2565 6.71095 15.274 6.53546V11.4626C15.274 15.0109 13.7704 16.8738 10.9979 16.8738C8.23687 16.8738 6.72756 15.009 6.72756 11.4626V6.53546C5.74503 6.71095 4.80678 6.95394 3.91655 7.24512V11.4915C3.91655 15.3908 7.08901 18.5747 10.9979 18.5747C14.9106 18.5747 18.083 15.3908 18.083 11.4915V7.24512H18.085Z",
    fill: "#7000FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzumIcon);
export default __webpack_public_path__ + "static/media/uzum_icon.2828c64c8b5f87362147190eba27495e.svg";
export { ForwardRef as ReactComponent };